import React from 'react'
import { Checkbox } from 'react-icheck'
import NavigationBar from '../Commons/NavigationBar'
import { getToken } from '../Commons/Authentication'
import { ToastContainer, ToastMessage } from 'react-toastr'
import RadioG from 'react-radio-group'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { hashHistory } from 'react-router'
import DefEmotState from '../../img/icons/general-icons/est_emo_0.png'
import DefPhysState from '../../img/icons/general-icons/est_fis_0.png'
import DefMentState from '../../img/icons/general-icons/est_men_0.png'
import DefSociState from '../../img/icons/general-icons/est_soc_0.png'
import 'icheck/skins/all.css'
import MiddleLine from '../../img/icons/general-icons/separator_icon.png'
// TODO: conectar mets en Square New Sprint
const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class PatientMedicalSquaresComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({
      edadVascular: '',
      reservaFunc: '',
      mets: '',
      isCheckedHTA: false,
      isCheckedDM: false,
      isCheckedDBO: false,
      fragilidadVal: '',
      sintomasVal: '',
      sintomaText: '',
      alimentacionVal: '',
      dreamsVal: '',
      relajacionVal: '',
      adiccionesVal: '',
      perspectivaVal: '',
      psValue: '',
      actividadesTLVal: '',
      perspectivagVal: '',
      tranquilidadVal: '',
      redFamiliarVal: '',
      trabajoVal: '',
      pensionadoVal: '',
      autonomiaVal: '',
      socialVal: '',
      oportunidadVal: '',
      HTA: null,
      par1: '',
      par2: '',
      par3: '',
      observaciones: '',
      squaresData: {},
      dirty: false,
      evInputClass: 'square-input',
      evTitle: '',
      evLabelClass: 'square-label',
      rfInputClass: 'square-input',
      rfTitle: '',
      rfLabelClass: 'square-label',
      mtInputClass: 'square-input',
      mtLabelClass: 'square-label',
      squareClass: 'health-square-medical left-square',
      phImage: DefPhysState,
      mtImage: DefMentState,
      emImage: DefEmotState,
      scImage: DefSociState,
      cronAge: ''
    })
  }

  handleFragilidad (value) {
    let newSquareData = this.state.squaresData
    newSquareData.fragilidad = value
    this.setState({ fragilidadVal: newSquareData, dirty: true })
  }

  handleSintomas (value) {
    let newSquareData = this.state.squaresData
    newSquareData.sintomas = value
    this.setState({ sintomasVal: newSquareData, dirty: true })
  }

  handleAlimentacion (value) {
    let newSquareData = this.state.squaresData
    newSquareData.alimentacion = value
    this.setState({ alimentacionVal: newSquareData, dirty: true })
  }

  handleDreams (value) {
    let newSquareData = this.state.squaresData
    newSquareData.dreams = value
    this.setState({ dreamsVal: newSquareData, dirty: true })

    if (value === 'm') {
      this.seState({ phAcumulador: this.state.phAcumulador + 1, squareClass: 'health-square-medical square-bad' })
    } else if (value === 'b' && this.state.phAcumulador === 0) {
      this.seState({ squareClass: 'health-square-medical square-good' })
    }
  }

  handleRelajacion (value) {
    let newSquareData = this.state.squaresData
    newSquareData.relajacion = value
    this.setState({ relajacionVal: newSquareData, dirty: true })
  }

  handleAdicciones (value) {
    let newSquareData = this.state.squaresData
    newSquareData.adicciones = value
    this.setState({ adiccionesVal: newSquareData, dirty: true })
  }

  handlePerspectiva (value) {
    let newSquareData = this.state.squaresData
    newSquareData.adversidades = value
    this.setState({ perspectivaVal: newSquareData, dirty: true })
  }

  handlePs (value) {
    let newSquareData = this.state.squaresData
    newSquareData.presentes = value
    this.setState({ psVal: newSquareData, dirty: true })
  }

  handleActividadesTL (value) {
    let newSquareData = this.state.squaresData
    newSquareData.tiempolibre = value
    this.setState({ actividadesTLVal: newSquareData, dirty: true })
  }

  handlePerspectivag (value) {
    let newSquareData = this.state.squaresData
    newSquareData.futuro = value
    this.setState({ perspectivagVal: newSquareData, dirty: true })
  }

  handleTranquilidad (value) {
    let newSquareData = this.state.squaresData
    newSquareData.tranquilidad = value
    this.setState({ tranquilidadVal: newSquareData, dirty: true })
  }

  handleRedFamiliar (value) {
    let newSquareData = this.state.squaresData
    newSquareData.redFamiliar = value
    this.setState({ redFamiliarVal: newSquareData, dirty: true })
  }

  handleTrabajo (value) {
    let newSquareData = this.state.squaresData
    newSquareData.trabajoAgradable = value
    this.setState({ trabajoVal: newSquareData, dirty: true })
  }

  handlePensionado (value) {
    let newSquareData = this.state.squaresData
    newSquareData.pensionado = value
    this.setState({ pensionadoVal: newSquareData, dirty: true })
  }

  handleAutonomia (value) {
    let newSquareData = this.state.squaresData
    newSquareData.autonomia = value
    this.setState({ autonomiaVal: newSquareData, dirty: true })
  }

  handleSocial (value) {
    let newSquareData = this.state.squaresData
    newSquareData.redSocial = value
    this.setState({ socialVal: newSquareData, dirty: true })
  }

  handleOportunidad (value) {
    let newSquareData = this.state.squaresData
    newSquareData.oportunidades = value
    this.setState({ oportunidadVal: newSquareData, dirty: true })
  }
  toggleChangeHTA () {
    this.setState({
      isCheckedHTA: !this.state.isCheckedHTA, dirty: true // flip boolean value
    })
  }
  toggleChangeDM () {
    this.setState({
      isCheckedDM: !this.state.isCheckedDM, dirty: true // flip boolean value
    })
  }
  toggleChangeDOB () {
    this.setState({
      isCheckedDOB: !this.state.isCheckedDOB, dirty: true // flip boolean value
    })
  }

  sintomasChange () {
    this.setState({ sintomaText: this.refs.descripcionSintomas.value, dirty: true })
  }

  handleObservaciones () {
    this.setState({ notasText: this.refs.observaciones.value, dirty: true })
  }

  handlePar1 (value) {
    let newSquareData = this.state.squaresData
    newSquareData.par1 = value
    this.setState({ par1: newSquareData, dirty: true })
  }

  handlePar2 (value) {
    let newSquareData = this.state.squaresData
    newSquareData.par2 = value
    this.setState({ par2: newSquareData, dirty: true })
  }

  handlePar3 (value) {
    let newSquareData = this.state.squaresData
    newSquareData.par3 = value
    this.setState({ par3: newSquareData, dirty: true })
  }

  componentWillMount () {
    this.loadPatientData()
  }

  loadPatientData () {
    let endpoint = `api/v1/patient/find?numeroDocumento=${this.props.params.patient}`
    request
    .get(endpoint)
    .set('Authorization', `Bearer ${getToken()}`)
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res.statusCode === 200) {
        let patient = res.body[0]
        let birthday = new Date(patient.fechaNacimiento.split('/').reverse().join('-'))
        let ageDifMs = Date.now() - birthday.getTime()
        let ageDate = new Date(ageDifMs)
        let age = Math.abs(ageDate.getUTCFullYear() - 1970)

        this.setState({cronAge: age, muerto: patient.muerto})
        console.log('Esta es la edad del paciente', this.state.cronAge)
      } else if (err) {
        this.refs.container.error('Algo inesperado ocurrió, no se encontro el paciente', '', {
          closeButton: true
        })
      }
    })
    this.findPatientSquares()
  }

  findPatientSquares () {
    let identificacion = this.props.params.patient
    request
      .get('api/v1/square/findSquareById')
      .query({ id: identificacion })
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err)
        } else {
          let patientSquare = res.body[0]
          this.setState({
            squaresData: patientSquare,
            squaresDataOriginal: patientSquare,
            edadVascular: patientSquare.edadVascular,
            reservaFunc: patientSquare.reservaFunc,
            mets: patientSquare.actividadFisica,
            sintomaText: patientSquare.descripcion,
            notasText: patientSquare.observaciones,
            isCheckedHTA: patientSquare.HTA,
            isCheckedDM: patientSquare.DM,
            isCheckedDOB: patientSquare.DOB
          })

          let diferenciaEdades = patientSquare.edadVascular - this.state.cronAge
          console.log('Esta es la edad del paciente restando las edades ', diferenciaEdades)
          if (diferenciaEdades < 6) {
            this.setState({
              evInputClass: 'square-input input-good',
              evLabelClass: 'square-label label-good'
            })
          } else if (diferenciaEdades >= 6) {
            this.setState({
              evInputClass: 'square-input input-bad',
              evLabelClass: 'square-label label-bad'
            })
          } else {
            this.state.evInputClass
            this.state.evTitle
          }
/*
          if (patientSquare.actividadFisica >= 7) {
            this.setState({
              mtInputClass: 'square-input input-good',
              mtLabelClass: 'square-label label-good'
            })
          } else if (patientSquare.actividadFisica < 7) {
            this.setState({
              mtInputClass: 'square-input input-bad',
              mtLabelClass: 'square-label label-bad'
            })
          } else {
            this.state.mtInputClass
          }
*/
          if (patientSquare.reservaFunc >= 60) {
            this.setState({
              rfInputClass: 'square-input input-good',
              rfLabelClass: 'square-label label-good'
            })
          } else if (patientSquare.reservaFunc < 60) {
            this.setState({
              rfInputClass: 'square-input input-bad',
              rfLabelClass: 'square-label label-bad'
            })
          } else {
            this.state.rfInputClass
          }
        }
      })
  }

  cuadrantesValues (e) {
    e.preventDefault()
    let cuadrantesData = {
      id: this.props.params.patient,
      edadVascular: this.refs.edadVascular.value,
      reservaFunc: this.refs.reservaFunc.value,
      fragilidad: this.refs.fragilidad.props.selectedValue,
      sintomas: this.refs.sintomas.props.selectedValue,
      descripcion: this.refs.descripcionSintomas.value,
      alimentacion: this.refs.alimentacion.props.selectedValue,
      dreams: this.refs.dream.props.selectedValue,
      actividadFisica: this.refs.actividadFisica.value,
      relajacion: this.refs.relajacion.props.selectedValue,
      adicciones: this.refs.adicciones.props.selectedValue,
      adversidades: this.refs.perspectiva.props.selectedValue,
      presentes: this.refs.tresps.props.selectedValue,
      tiempolibre: this.refs.actividadesTL.props.selectedValue,
      futuro: this.refs.perspectivaG.props.selectedValue,
      tranquilidad: this.refs.tranquilidad.props.selectedValue,
      redFamiliar: this.refs.redFamiliar.props.selectedValue,
      trabajoAgradable: this.refs.trabajo.props.selectedValue,
      pensionado: this.refs.pensionado.props.selectedValue,
      autonomia: this.refs.autonomia.props.selectedValue,
      redSocial: this.refs.social.props.selectedValue,
      oportunidades: this.refs.oportunidad.props.selectedValue,
      par1: this.refs.par1.props.selectedValue,
      par2: this.refs.par2.props.selectedValue,
      par3: this.refs.par3.props.selectedValue,
      HTA: this.refs.HTA.isChecked(),
      DM: this.refs.DM.isChecked(),
      DOB: this.refs.DOB.isChecked(),
      observaciones: this.refs.observaciones.value
    }
    let url = 'api/v1/square/register'
    request
    .post(url)
    .use(NoCache)
    .set('Authorization', 'Bearer ' + getToken())
    .send(cuadrantesData)
    .end((err, res) => {
      if (err) {
        this.refs.container.error('Algo inesperado paso y no se pudo guardar la información', '', {
          closeButton: true
        })
      } else {
        this.refs.container.success('Los datos se guardaron correctamente', 'Cuadrantes Guardados', {
          closeButton: true
        })
        setTimeout(() => { hashHistory.push('estadoSaludDashboard/' + this.props.params.patient) }, 2800)
      }
      console.log('Guardado')
    })
  }

  dashboardRedirect () {
    console.log('Redirect Dashboard')
    hashHistory.push('estadoSaludDashboard/' + this.props.params.patient)
  }

  cancelFunction (e) {
    e.preventDefault()
    if (this.state.dirty === true) {
      console.log('terribles cambios')
      this.refs.container.warning(<span className='center-content'>Tiene cambios pendientes ¿Desea regresar al Dashboard de todos modos? <br /><br /><span className='email-validation-container'><button type='button' className='btn btn-confirm clear' onClick={this.dashboardRedirect.bind(this)}>Si</button><button type='button' className='btn btn-confirm clear'>No</button></span></span>, <em>Tiene cambios pendientes</em>, {
        closeButton: true,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': 0,
        'extendedTimeOut': 0,
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
      })
    } else {
      this.dashboardRedirect()
    }
  }

  render () {
    document.title = 'Cuadrantes - CORE 3.0'
    return (
      <div className='health-square-container-section'>
        <NavigationBar dirty={this.state.dirty}/>
        <div className='square-container-main'>
          <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
          <div className='health-squares top-squares'>
            <div className='health-square-medical left-square'>
              <div className='square-header'>
                <img className='state-img-squares' src={DefPhysState}/>
                <div className='state-text-squares'>Estado Físico</div>
              </div>
              <div className='physics-squares-calcs'>
                <div className='square-up-container'>
                  <div className='physics-left'>
                    <div className='initial-calcs-fields'>
                      <div className='square-labels-fields'>
                        <label className={this.state.evLabelClass}>Edad arterial (EA):</label>
                        <label className={this.state.rfLabelClass}>Reserva funcional (RF):</label>
                      </div>
                      <div className='square-inputs-fields'>
                        <input id='edadVascular' ref='edadVascular' name='edadVascular' className={this.state.evInputClass} value={this.state.edadVascular} disabled/>
                        <input id='reservaFunc' ref='reservaFunc' name='reservaFunc' className={this.state.rfInputClass} value={this.state.reservaFunc} disabled/>
                      </div>
                    </div>
                    <div className='check-container'>
                      <label className='square-label square-label-check'>Riesgos y morbilidades:</label>
                      <div className='check-fields-container'>
                        <div className='check-input'><Checkbox ref='HTA' checkboxClass='icheckbox_square-blue'checked={this.state.isCheckedHTA} onChange={this.toggleChangeHTA.bind(this)} increaseArea='16%' label='HTA' /></div>
                        <div className='check-input'><Checkbox ref='DM' checkboxClass='icheckbox_square-blue'checked={this.state.isCheckedDM} onChange={this.toggleChangeDM.bind(this)} increaseArea='16%' label='DM'/></div>
                        <div className='check-input'><Checkbox ref='DOB' checkboxClass='icheckbox_square-blue'checked={this.state.isCheckedDOB} onChange={this.toggleChangeDOB.bind(this)} increaseArea='16%' label='DOB'/></div>
                      </div>
                    </div>
                  </div>
                  <div className='physics-right'>
                    <div className='initial-calcs-fields'>
                      <div className='square-labels-fields'>
                        <label className='square-label'>Fragilidad:</label>
                        <label className='square-label'>Síntomas:</label>
                      </div>
                      <div className='square-inputs-fields'>
                        <div className='form-group'>
                          <RadioG id='fragilidad' ref='fragilidad' name='fragilidad-group' selectedValue={this.state.squaresData.fragilidad ? this.state.squaresData.fragilidad : this.state.fragilidadVal} onChange={this.handleFragilidad.bind(this)}>
                            {Radio => (
                              <div className='option-switch-container'>
                                <Radio id='fragilidadS' ref='fragilidadS' name='fragilidad-group' value='Si' className='option-switch-input'/>
                                <label htmlFor='fragilidadS' className='option-switch-label color-bad'>Si</label>
                                <Radio id='fragilidadN' ref='fragilidadN' name='fragilidad-group' value='No' className='option-switch-input'/>
                                <label htmlFor='fragilidadN' className='option-switch-label color-good'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                        <div className='form-group'>
                          <RadioG id='sintomas' ref='sintomas' name='sintomas-group' selectedValue={this.state.squaresData.sintomas ? this.state.squaresData.sintomas : this.state.sintomasVal} onChange={this.handleSintomas.bind(this)}>
                            {Radio => (
                              <div className='option-switch-container'>
                                <Radio id='sintomasS' ref='sintomasS' name='chooser' value='Si' className='option-switch-input'/>
                                <label htmlFor='sintomasS' className='option-switch-label color-bad'>Si</label>
                                <Radio id='sintomasN' ref='sintomasN' name='chooser' value='No' className='option-switch-input'/>
                                <label htmlFor='sintomasN' className='option-switch-label color-good'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                      </div>
                    </div>
                    <div className='check-container'>
                      <textarea ref='descripcionSintomas' placeholder='Descripción de síntomas' value={this.state.sintomaText} onChange={this.sintomasChange.bind(this)}/>
                    </div>
                  </div>
                </div>
                <div className='square-down-container'>
                  <label className='square-label habits-label-title'>Hábitos de vida y autocuidado:</label>
                  <div className='square-down-container-element'>
                    <div className='physics-left'>
                      <div className='radio-container'>
                        <div className='habits-container'>
                          <div className='radio-habits-container-labels'>
                            <label className='habits-label'>Alimentación:</label>
                            <label className='habits-label'>Sueño:</label>
                            <label className='habits-label'>Relajación:</label>
                          </div>
                          <div className='habit-options'>
                            <div className='form-group'>
                              <RadioG id='alimentacion' ref='alimentacion' name='alimentacion-group' selectedValue={this.state.squaresData.alimentacion ? this.state.squaresData.alimentacion : this.state.alimentacionVal} onChange={this.handleAlimentacion.bind(this)}>
                                {Radio => (
                                  <div className='habits-switch-container'>
                                    <Radio id='alimentacionB' ref='alimentacionB' name='chooser' value='b' className='habits-switch-input'/>
                                    <label htmlFor='alimentacionB' className='habits-switch-label color-one'>B</label>
                                    <Radio id='alimentacionN' ref='alimentacionN' name='chooser' value='n' className='habits-switch-input'/>
                                    <label htmlFor='alimentacionN' className='habits-switch-label color-two'>N</label>
                                    <Radio id='alimentacionM' ref='alimentacionM' name='chooser' value='m' className='habits-switch-input'/>
                                    <label htmlFor='alimentacionM' className='habits-switch-label color-three'>M</label>
                                </div>
                                )}
                              </RadioG>
                            </div>
                            <div className='form-group'>
                              <RadioG id='dream' ref='dream' name='sueño-group' selectedValue={this.state.squaresData.dreams ? this.state.squaresData.dreams : this.state.dreamsVal} onChange={this.handleDreams.bind(this)}>
                                {Radio => (
                                  <div className='habits-switch-container'>
                                    <Radio id='sueñoB' ref='sueñoB' name='chooser' value='b' className='habits-switch-input'/>
                                    <label htmlFor='sueñoB' className='habits-switch-label color-one'>B</label>
                                    <Radio id='sueñoN' ref='sueñoN' name='chooser' value='n' className='habits-switch-input'/>
                                    <label htmlFor='sueñoN' className='habits-switch-label color-two'>N</label>
                                    <Radio id='sueñoM' ref='sueñoM' name='chooser' value='m' className='habits-switch-input'/>
                                    <label htmlFor='sueñoM' className='habits-switch-label color-three'>M</label>
                                </div>
                                )}
                              </RadioG>
                            </div>
                            <div className='form-group'>
                              <RadioG id='relajacion' ref='relajacion' name='relajacion-group' selectedValue={this.state.squaresData.relajacion ? this.state.squaresData.relajacion : this.state.relajacionVal} onChange={this.handleRelajacion.bind(this)}>
                                {Radio => (
                                  <div className='habits-switch-container'>
                                    <Radio id='relajacionB' ref='relajacionB' name='chooser' value='b' className='habits-switch-input'/>
                                    <label htmlFor='relajacionB' className='habits-switch-label color-one'>B</label>
                                    <Radio id='relajacionN' ref='relajacionN' name='chooser' value='n' className='habits-switch-input'/>
                                    <label htmlFor='relajacionN' className='habits-switch-label color-two'>N</label>
                                    <Radio id='relajacionM' ref='relajacionM' name='chooser' value='m' className='habits-switch-input'/>
                                    <label htmlFor='relajacionM' className='habits-switch-label color-three'>M</label>
                                </div>
                                )}
                              </RadioG>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='physics-right'>
                      <div className='initial-calcs-fields'>
                        <div className='square-labels-fields square-labels-fields-frg'>
                          <label className='square-label'>Adicciones:</label>
                          <label className={this.state.mtLabelClass}>Actividad física:</label>
                        </div>
                        <div className='square-inputs-fields'>
                          <div className='form-group'>
                            <RadioG id='adicciones' ref='adicciones' name='Adicciones-group' selectedValue={this.state.squaresData.adicciones ? this.state.squaresData.adicciones : this.state.adiccionesVal} onChange={this.handleAdicciones.bind(this)}>
                              {Radio => (
                                <div className='option-switch-container'>
                                  <Radio id='AdiccionesS' ref='AdiccionesS' name='chooser' value='Si' className='option-switch-input'/>
                                  <label htmlFor='AdiccionesS' className='option-switch-label color-bad'>Si</label>
                                  <Radio id='AdiccionesN' ref='AdiccionesN' name='chooser' value='No' className='option-switch-input'/>
                                  <label htmlFor='AdiccionesN' className='option-switch-label color-good'>No</label>
                                </div>
                              )}
                            </RadioG>
                          </div>
                          <div className='square-inputs-fields'>
                            <div className='square-activity'>
                              <input id='actividadFisica' ref='actividadFisica' name='actividadFisica' className={this.state.mtInputClass} value={this.state.mets} disabled/>
                              <span className='square-mets'></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='health-square-medical right-square'>
              <div className='square-header'>
                <img className='state-img-squares' src={DefMentState}/>
                <div className='state-text-squares'>Estado Mental</div>
              </div>
              <div className='physics-squares-calcs'>
                <div className='square-up-container'>
                  <div className='physics-left'>
                    <div className='initial-calcs-fields'>
                      <div className='square-labels-fields square-labels-fields-soc'>
                        <label className='square-label square-label-ment'>¿Perspectiva personal frente a: Dificultades/Adversidades pasadas/presentes?</label>
                        <label className='square-label square-label-ment'>¿3PS: propósitos, proyectos, planes?</label>
                        <label className='square-label square-label-ment'>¿Actividades de tiempo libre?</label>
                        <label className='square-label square-label-ment'>¿Perspectiva global (futuro)?</label>
                        <label className='square-label square-label-ment'>¿Tranquilidad financiera/necesidades satisfechas?</label>
                      </div>
                      <div className='square-inputs-fields '>
                        <div className='form-group'>
                          <RadioG id='perspectiva' ref='perspectiva' name='Perspectiva-group' selectedValue={this.state.squaresData.adversidades ? this.state.squaresData.adversidades : this.state.perspectivaVal} onChange={this.handlePerspectiva.bind(this)}>
                            {Radio => (
                              <div className='mental-switch-container'>
                                <Radio id='PerspectivaP' ref='PerspectivaP' name='chooser' value='Positiva' className='mental-switch-input'/>
                                <label htmlFor='PerspectivaP' className='mental-switch-label color-positive'>Positiva</label>
                                <Radio id='PerspectivaN' ref='PerspectivaN' name='mental' value='Negativa' className='mental-switch-input'/>
                                <label htmlFor='PerspectivaN' className='mental-switch-label color-negative'>Negativa</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                        <div className='form-group'>
                          <RadioG id='tresps' ref='tresps' name='3ps-group' selectedValue={this.state.squaresData.presentes ? this.state.squaresData.presentes : this.state.psVal} onChange={this.handlePs.bind(this)}>
                            {Radio => (
                              <div className='mental-switch-container'>
                                <Radio id='3PSS' ref='3PSS' name='chooser' value='Si' className='mental-switch-input'/>
                                <label htmlFor='3PSS' className='mental-switch-label color-positive'>Si</label>
                                <Radio id='3PSN' ref='3PSN' name='chooser' value='No' className='mental-switch-input'/>
                                <label htmlFor='3PSN' className='mental-switch-label color-negative'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                        <div className='form-group'>
                          <RadioG id='actividadesTL' ref='actividadesTL' name='actividadesTL-group' selectedValue={this.state.squaresData.tiempolibre ? this.state.squaresData.tiempolibre : this.state.actividadesTLVal} onChange={this.handleActividadesTL.bind(this)}>
                            {Radio => (
                              <div className='mental-switch-container'>
                                <Radio id='actividadesTLS' ref='actividadesTLS' name='chooser' value='Si' className='mental-switch-input'/>
                                <label htmlFor='actividadesTLS' className='mental-switch-label color-positive'>Si</label>
                                <Radio id='actividadesTLN' ref='actividadesTLN' name='chooser' value='No' className='mental-switch-input'/>
                                <label htmlFor='actividadesTLN' className='mental-switch-label color-negative'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                        <div className='form-group'>
                          <RadioG id='perspectivaG' ref='perspectivaG' name='PerspectivaG-group' selectedValue={this.state.squaresData.futuro ? this.state.squaresData.futuro : this.state.perspectivagVal} onChange={this.handlePerspectivag.bind(this)}>
                            {Radio => (
                              <div className='mental-switch-container'>
                                <Radio id='PerspectivaGO' ref='PerspectivaGO' name='chooser' value='Optimismo' className='mental-switch-input'/>
                                <label htmlFor='PerspectivaGO' className='mental-switch-label color-positive'>Optimismo</label>
                                <Radio id='PerspectivaGPP' ref='PerspectivaGPP' name='mental' value='Pesimismo' className='mental-switch-input'/>
                                <label htmlFor='PerspectivaGPP' className='mental-switch-label color-negative'>Pesimismo</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                        <div className='form-group'>
                          <RadioG id='tranquilidad' ref='tranquilidad' name='Tranquilidad-group' selectedValue={this.state.squaresData.tranquilidad ? this.state.squaresData.tranquilidad : this.state.tranquilidadVal} onChange={this.handleTranquilidad.bind(this)}>
                            {Radio => (
                              <div className='mental-switch-container'>
                                <Radio id='TranquilidadS' ref='TranquilidadS' name='chooser' value='Si' className='mental-switch-input'/>
                                <label htmlFor='TranquilidadS' className='mental-switch-label color-positive'>Si</label>
                                <Radio id='TranquilidadN' ref='TranquilidadN' name='chooser' value='No' className='mental-switch-input'/>
                                <label htmlFor='TranquilidadN' className='mental-switch-label color-negative'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='health-squares'>
            <div className='health-square-medical left-square'>
              <div className='square-header'>
                <img className='state-img-squares' src={DefSociState}/>
                <div className='state-text-squares'>Estado Social</div>
              </div>
              <div className='physics-squares-calcs'>
                <div className='square-up-container'>
                  <div className='physics-left'>
                    <div className='initial-calcs-fields'>
                      <div className='square-labels-fields square-labels-fields-soc'>
                        <label className='square-label'>Red familiar de apoyo</label>
                        <label className='square-label'>Trabajo (agradable)?</label>
                      </div>
                      <div className='square-inputs-fields '>
                        <div className='form-group'>
                          <RadioG id='redFamiliar' ref='redFamiliar' name='redFamiliar-group' selectedValue={this.state.squaresData.redFamiliar ? this.state.squaresData.redFamiliar : this.state.redFamiliarVal} onChange={this.handleRedFamiliar.bind(this)}>
                            {Radio => (
                              <div className='option-switch-container'>
                                <Radio id='redFamiliarS' ref='redFamiliarS' name='chooser' value='Si' className='option-switch-input'/>
                                <label htmlFor='redFamiliarS' className='option-switch-label color-good'>Si</label>
                                <Radio id='redFamiliarN' ref='redFamiliarN' name='chooser' value='No' className='option-switch-input'/>
                                <label htmlFor='redFamiliarN' className='option-switch-label color-bad'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                        <div className='form-group'>
                          <RadioG id='trabajo' ref='trabajo' name='trabajo-group' selectedValue={this.state.squaresData.trabajoAgradable ? this.state.squaresData.trabajoAgradable : this.state.trabajoVal} onChange={this.handleTrabajo.bind(this)}>
                            {Radio => (
                              <div className='option-switch-container'>
                                <Radio id='trabajoS' ref='trabajoS' name='chooser' value='Si' className='option-switch-input'/>
                                <label htmlFor='trabajoS' className='option-switch-label color-good'>Si</label>
                                <Radio id='trabajoN' ref='trabajoN' name='chooser' value='No' className='option-switch-input'/>
                                <label htmlFor='trabajoN' className='option-switch-label color-bad'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='physics-right'>
                    <div className='initial-calcs-fields'>
                      <div className='square-labels-fields square-labels-fields-soc'>
                        <label className='square-label'>¿Es Pensionado?</label>
                        <label className='square-label'>¿Autonomía?</label>
                      </div>
                      <div className='square-inputs-fields'>
                        <div className='form-group'>
                          <RadioG id='pensionado' ref='pensionado' name='pensionado-group' selectedValue={this.state.squaresData.pensionado ? this.state.squaresData.pensionado : this.state.pensionadoVal} onChange={this.handlePensionado.bind(this)}>
                            {Radio => (
                              <div className='option-switch-container'>
                                <Radio id='pensionadoS' ref='pensionadoS' name='chooser' value='Si' className='option-switch-input'/>
                                <label htmlFor='pensionadoS' className='option-switch-label color-bad'>Si</label>
                                <Radio id='pensionadoN' ref='pensionadoN' name='chooser' value='No' className='option-switch-input'/>
                                <label htmlFor='pensionadoN' className='option-switch-label color-good'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                        <div className='form-group'>
                          <RadioG id='autonomia' ref='autonomia' name='autonomia-group' selectedValue={this.state.squaresData.autonomia ? this.state.squaresData.autonomia : this.state.autonomiaVal} onChange={this.handleAutonomia.bind(this)}>
                            {Radio => (
                              <div className='option-switch-container'>
                                <Radio id='autonomiaS' ref='autonomiaS' name='chooser' value='Si' className='option-switch-input'/>
                                <label htmlFor='autonomiaS' className='option-switch-label color-good'>Si</label>
                                <Radio id='autonomiaN' ref='autonomiaN' name='chooser' value='No' className='option-switch-input'/>
                                <label htmlFor='autonomiaN' className='option-switch-label color-bad'>No</label>
                              </div>
                            )}
                          </RadioG>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='square-down-container'>
                    <div className='physics-left'>
                      <div className='radio-container'>
                        <div className='habits-container'>
                          <div className='radio-habits-container-labels'>
                            <label className='habits-label square-labels-fields-soc'>Red Social: Amigos cercanos? Pertenece a grupos? (Tercera edad, obras sociales, iglesia)</label>
                            <label className='habits-label square-labels-fields-soc'>Oportunidades (de progreso) personal, laboral</label>
                          </div>
                          <div className='habit-options'>
                            <div className='form-group'>
                              <RadioG id='social' ref='social' name='social-group' selectedValue={this.state.squaresData.redSocial ? this.state.squaresData.redSocial : this.state.socialVal} onChange={this.handleSocial.bind(this)}>
                                {Radio => (
                                  <div className='option-switch-container'>
                                    <Radio id='socialS' ref='socialS' name='chooser' value='Si' className='option-switch-input'/>
                                    <label htmlFor='socialS' className='option-switch-label color-good'>Si</label>
                                    <Radio id='socialN' ref='socialN' name='chooser' value='No' className='option-switch-input'/>
                                    <label htmlFor='socialN' className='option-switch-label color-bad'>No</label>
                                  </div>
                                )}
                              </RadioG>
                            </div>
                            <div className='form-group'>
                              <RadioG id='oportunidad' ref='oportunidad' name='oportunidad-group' selectedValue={this.state.squaresData.oportunidades ? this.state.squaresData.oportunidades : this.state.oportunidadVal} onChange={this.handleOportunidad.bind(this)}>
                                {Radio => (
                                  <div className='option-switch-container'>
                                    <Radio id='oportunidadS' ref='oportunidadS' name='chooser' value='Si' className='option-switch-input'/>
                                    <label htmlFor='oportunidadS' className='option-switch-label color-good'>Si</label>
                                    <Radio id='oportunidadN' ref='oportunidadN' name='chooser' value='No' className='option-switch-input'/>
                                    <label htmlFor='oportunidadN' className='option-switch-label color-bad'>No</label>
                                  </div>
                                )}
                              </RadioG>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            <div className='health-square-medical right-square '>
              <div className='square-header'>
                <img className='state-img-squares' src={DefEmotState}/>
                <div className='state-text-squares'>Estado Emocional</div>
              </div>
              <div className='physics-squares-calcs emotional-conditions-container'>
                <div>
                  <label className='square-label habits-label-title'>Elija dos (una de cada lado):</label>
                  <div className='square-up-container'>
                    <div className='physics-left-emotional'>
                      <RadioG id='par1' ref='par1' selectedValue={this.state.squaresData.par1 ? this.state.squaresData.par1 : this.state.par1} onChange={this.handlePar1.bind(this)}>
                        {Radio => (
                          <div>
                            <div className='radio-container'>
                              <Radio id='contento' ref='contento' className='radio-input radio-input-ok' name='chooser' value='Contento'/>
                              <label htmlFor='contento' className='radio-label-ok'>Contento</label>
                            </div>
                            <div className='radio-container'>
                              <Radio id='descontento' ref='descontento' className='radio-input radio-input-bad' name='chooser' value='Descontento'/>
                              <label htmlFor='descontento' className='radio-label-bad'>Descontento</label>
                            </div>
                          </div>
                        )}
                      </RadioG>
                    </div>
                    <img className='middleline middleline-patient' src={MiddleLine} />
                    <div className='physics-right-emotional'>
                      <RadioG id='par2' ref='par2' selectedValue={this.state.squaresData.par2 ? this.state.squaresData.par2 : this.state.par2} onChange={this.handlePar2.bind(this)}>
                        {Radio => (
                          <div>
                            <div className='radio-container'>
                              <Radio id='Expresivo' ref='Expresivo' className='radio-input radio-input-ok' name='chooser' value='Expresivo'/>
                              <label htmlFor='Expresivo' className='radio-label-ok'>Expresivo</label>
                            </div>
                            <div className='radio-container'>
                              <Radio id='Calmado' ref='Calmado' className='radio-input radio-input-ok' name='chooser' value='Calmado'/>
                              <label htmlFor='Calmado' className='radio-label-ok'>Calmado</label>
                            </div>
                          </div>
                        )}
                      </RadioG>
                    </div>
                  </div>
                </div>
                <img className='middleline middleline-emotional' src={MiddleLine} />
                <div className='emotional-conditions-options'>
                  <label className='square-label habits-label-title'>Por percepción elija la palabra que mejor describa la persona:</label>
                  <div className='square-up-container'>
                    <div className='physics-left-emotional'>
                      <RadioG id='par3' ref='par3' selectedValue={this.state.squaresData.par3 ? this.state.squaresData.par3 : this.state.par3} onChange={this.handlePar3.bind(this)}>
                        {Radio => (
                          <div>
                            <div className='radio-container'>
                              <Radio id='Descontentoan' ref='Descontentoan' className='radio-input radio-input-bad' name='chooser' value='Irritable : DEA'/>
                              <label htmlFor='Descontentoan' className='radio-label-bad'>Irritable : DEA</label>
                            </div>
                            <div className='radio-container'>
                              <Radio id='Entusiasta' ref='Entusiasta' className='radio-input radio-input-ok' name='chooser' value='Entusiasta'/>
                              <label htmlFor='Entusiasta' className='radio-label-ok'>Entusiasta</label>
                            </div>
                            <div className='radio-container'>
                              <Radio id='Decaido' ref='Decaido' className='radio-input radio-input-bad' name='chooser' value='Decaído'/>
                              <label htmlFor='Decaido' className='radio-label-bad'>Decaído</label>
                            </div>
                            <div className='radio-container'>
                              <Radio id='Tranquilo' ref='Tranquilo' className='radio-input radio-input-ok' name='chooser' value='Tranquilo'/>
                              <label htmlFor='Tranquilo' className='radio-label-ok'>Tranquilo</label>
                            </div>
                          </div>
                        )}
                      </RadioG>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='health-square-medical squares-notes'>
          <div className='state-text-squares'>Notas / Observaciones:</div>
          <div className='physics-squares-notes'>
            <textarea ref='observaciones' value={this.state.notasText} onChange={this.handleObservaciones.bind(this)}/>
          </div>
        </div>
        <div className='form-submit-btn-container'>
          <button id='cancelSquares' className='form-submit-button save-button' onClick={this.cancelFunction.bind(this)}>⟵ Regresar</button>
          {this.state.muerto ? '' : <button id='saveSquares' className='form-submit-button save-button' onClick={this.cuadrantesValues.bind(this)}>Guardar</button> }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/PatientMedicalSquares.js